import styled from "styled-components";
import { getTheme, themed, Box, Input, Dropdown, Text, } from "@bracket/ui";
import type { FunctionComponent, } from "react";
import type { TokenDefinition, } from "@bracket/chainography";



export declare type DepositAmountInputProps = {
	disabled?: boolean;
	selectedToken: TokenDefinition;
	onAmountChange: (amount: string) => void;
	amount: string
	displayTokenSelector:boolean;
};



/**
 * A component that combines a token selector dropdown with an amount input field.
 * Used for entering token amounts in swap/trade interfaces.
 * 
 * @component
 * @param {Object} props - Component props
 * @param {boolean} [props.disabled=false] - Whether the input is disabled
 * @returns {JSX.Element} A token amount input component
 */
export const DepositAmountInput: FunctionComponent<DepositAmountInputProps> = ({
	disabled = false,
	selectedToken,
	onAmountChange,
	amount,
	displayTokenSelector,
}) => {
	themed();

	return (
		<InputContainer>
			<Dropdown<TokenDefinition>
				items={[selectedToken]}
				selectedItem={selectedToken}
				onSelect={() => {}}
				disabled={disabled}
				renderItem={token => {
					return (
						<>
							<ImageBrace $url={`url(${token?.logoURI || token?.logo})`} />
							<Text md>{token.symbol}</Text>
						</>
					);
				}}
				renderSelectedItem={token => {
					return (
						<>
							<ImageBrace $url={`url(${token?.logoURI || token?.logo})`} />
							<Text md>{token?.symbol}</Text>
						</>
					);
				}}
			/>
			<StyledInput value={amount} onChange={onAmountChange} disabled={disabled} type="text" pattern="\d+(\.\d*)?" />
		</InputContainer>
	);
};

const ImageBrace = styled(Box)<{ $url: string; }>`
	width: 24px;
	height: 24px;
	margin-right: 8px;
	background-image: ${props => props.$url};
	background-size: contain;
	align-items: center;
	justify-content: center;
	background-repeat: no-repeat;
`;

const InputContainer = styled(Box)`
	background-color: ${() => getTheme().surface_container_lowest};
	color: ${() => getTheme().surface_on};
	border-radius: 8px;
	overflow: hidden;
	height: 88px;
	align-items: center;
`;

const StyledInput = styled(Input)`
	margin-left: -350px;
	color: inherit;
	background-color: ${() => getTheme().surface_container};
	padding: 2rem;
	border: ${() => getTheme().radials.md};
	font-family: ${() => getTheme().fonts.heading};
	/* Ensure decimal separator is always a period */
	&::-webkit-inner-spin-button,
	&::-webkit-outer-spin-button {
		-webkit-appearance: none;
		margin: 0;
	}
`;
